module.exports = __webpack_public_path__ + "static/media/Pre-existing.3bc2ce8f.svg";